import React, { useState } from 'react';
import AdminLoginPanel from './AdminLoginPanel';
import AdminDashboard from './AdminDashboard';

const AdminMain = () => {
    const [token, setToken] = useState(localStorage.getItem("tokenAdmin") || null);

    const handleLoginSuccess = (jwt) => {
        setToken(jwt);
        localStorage.setItem("tokenAdmin", jwt);
    };

    const handleLogout = () => {
        setToken(null);
        localStorage.removeItem("tokenAdmin");
    };

    return (
        <>
            {token ? (
                <AdminDashboard token={token} onLogout={handleLogout} />
            ) : (
                <AdminLoginPanel onLoginSuccess={handleLoginSuccess} />
            )}
        </>
    );
};

export default AdminMain;